// =============================================================================
// SettingsPage — platform administration settings (tab layout)
// =============================================================================
// Child routes render inside <Outlet/>. Keep the tab labels 1:1 with the
// routes defined in App.tsx so the active style stays in sync.
// =============================================================================

import { NavLink, Outlet } from 'react-router';

const TABS = [
  { to: 'general', label: 'General' },
  { to: 'shipping', label: 'Shipping' },
  { to: 'image-tools', label: 'Image Tools' },
  { to: 'fonts', label: 'Fonts' },
  { to: 'product-options', label: 'Product Options' },
] as const;

export function SettingsPage() {
  return (
    <div className="space-y-6">
      <header>
        <h1 className="text-xl font-semibold text-text-primary">
          System Settings
        </h1>
        <p className="mt-1 text-sm text-text-tertiary">
          Platform-wide configuration. Changes here affect every tenant.
        </p>
      </header>

      <nav
        className="flex gap-6 border-b border-border-subtle"
        aria-label="Settings sections"
      >
        {TABS.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            className={({ isActive }) =>
              [
                'relative -mb-px border-b-2 px-1 py-3 text-sm font-medium transition-colors',
                isActive
                  ? 'border-primary text-text-primary'
                  : 'border-transparent text-text-tertiary hover:text-text-primary',
              ].join(' ')
            }
          >
            {tab.label}
          </NavLink>
        ))}
      </nav>

      <Outlet />
    </div>
  );
}
